<mat-toolbar
  fxLayout="row"
  fxLayoutAlign="center center"
  [class.auto-height]="heightType === heightTypeEnum.AUTO"
  [ngStyle]="toolbarStyle"
  ngClass.sm="sm"
  ngClass.xs="xs"
>
  <div
    #content
    [style.maxWidth]="maxWidth"
    [style.paddingLeft]="padding"
    [style.paddingRight]="padding"
    class="content"
  >
    <ng-content></ng-content>
  </div>
</mat-toolbar>

<div
  class="spacer"
  ngClass.xs="xs"
  [style.height.px]="handsetService.isXs ? (heightType === heightTypeEnum.AUTO ? content.offsetHeight : 56) : 64"
></div>
